import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import TrackShipment from './pages/TrackShipment';
import GetQuote from './pages/GetQuote';
import Careers from './pages/Careers';

// Admin Components
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import DashboardHome from './pages/admin/DashboardHome';
import QuotesList from './pages/admin/QuotesList';
import QuoteDetail from './pages/admin/QuoteDetail';
import ContactsList from './pages/admin/ContactsList';
import ContactDetail from './pages/admin/ContactDetail';
import CareersList from './pages/admin/CareersList';
import CareerDetail from './pages/admin/CareerDetail';
import { isAuthenticated } from './services/adminAuth';

import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes with Navbar/Footer */}
        <Route path="/*" element={
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/track" element={<TrackShipment />} />
              <Route path="/quote" element={<GetQuote />} />
              <Route path="/careers" element={<Careers />} />
            </Routes>
            <Footer />
          </div>
        } />

        {/* Admin Routes without Navbar/Footer */}
        <Route path="/admin" element={
          isAuthenticated() ? <Navigate to="/admin/dashboard" replace /> : <Navigate to="/admin/login" replace />
        } />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />}>
          <Route index element={<DashboardHome />} />
          <Route path="quotes" element={<QuotesList />} />
          <Route path="quotes/:id" element={<QuoteDetail />} />
          <Route path="contacts" element={<ContactsList />} />
          <Route path="contacts/:id" element={<ContactDetail />} />
          <Route path="careers" element={<CareersList />} />
          <Route path="careers/:id" element={<CareerDetail />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

